import React, { useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    // LinearProgress,
    Typography
} from "@mui/material";
import { styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom";
import Header from '../../components/Header';
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
// import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
// import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export default function ImportarGuias() {
    const navigate = useNavigate();

    const [filesSelected, setFilesSelected] = useState([]);
    const [loading, setLoading] = useState(false);


    const handleProcessFiles = async () => {
        try {
            setLoading(true);
            const formData = new FormData();

            formData.append("guias", filesSelected[0]);

            const response = await axios.post(`${process.env.REACT_APP_API_URL}/guias/importar`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: localStorage.getItem('token'),
                }, 
            });
            console.log("Arquivos enviados com sucesso:", response.data);
            setFilesSelected([]);
            setLoading(false);
            alert("Arquivos processados com sucesso!");
        } catch (error) {
            console.error("Erro ao enviar arquivos:", error);
        }
    };

    return (
        <div>
            <Header />
            <div style={{ width: '100%', height: '90vh', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '90%', marginTop: 20 }}>
                    <div role="presentation">
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" onClick={() => navigate("../dashboard")}>
                                Dashboard
                            </Link>
                            <Link underline="hover" color="inherit" onClick={() => navigate("../obrigacoes")}>
                                Obrigações
                            </Link>
                            <Typography sx={{ color: 'text.primary' }}>Importar Guias</Typography>
                        </Breadcrumbs>
                    </div>
                    <div>
                        <h2>Importação de Guias</h2>
                    </div>
                    <div>
                        <h3>Gerencie e processe seus arquivos fiscais de forma automatizada e eficiente</h3>
                    </div>
                    {/* // tabela para consultar cliente */}
                    <div style={{ width: "100%", overflowX: "auto", marginTop: "20px" }}>
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                gap: 2,
                                flexWrap: { xs: "wrap", md: "nowrap" },
                            }}
                        >
                            {/* LADO ESQUERDO */}
                            <Box
                                sx={{
                                    flex: 1.8,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                    minWidth: "320px",
                                }}
                            >
                                {/* Upload */}
                                <Card
                                    sx={{
                                        border: "2px dashed #d6d6d6",
                                        minHeight: 320,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "none",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 70,
                                                height: 70,
                                                borderRadius: "50%",
                                                background: "#EEF4FF",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "0 auto 20px",
                                            }}
                                        >
                                            <CloudUploadOutlinedIcon
                                                sx={{
                                                    fontSize: 35,
                                                    color: "#2563EB",
                                                }}
                                            />
                                        </Box>

                                        <Typography variant="h6" fontWeight={600}>
                                            Importação de Guias
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#666",
                                                mt: 1,
                                                mb: 3,
                                            }}
                                        >
                                            Selecione a pasta compactada onde contém as guias fiscais desejadas.
                                        </Typography>

                                        <Button
                                            disabled={loading}
                                            component="label"
                                            variant="contained"
                                            startIcon={<CloudUploadIcon />}
                                            sx={{
                                                borderRadius: 3,
                                                px: 3,
                                                py: 1.2,
                                                textTransform: "none",
                                                fontWeight: 600,
                                            }}
                                        >
                                            Selecionar Arquivos Compactados

                                            <VisuallyHiddenInput
                                                type="file"
                                                accept=".zip"
                                                onChange={(event) => {
                                                    const arquivos = Array.from(event.target.files || []);
                                                    const extensoesPermitidas = [".zip"];
                                                    const arquivosValidos = arquivos.filter((arquivo) =>
                                                        extensoesPermitidas.some((ext) =>
                                                            arquivo.name.toLowerCase().endsWith(ext)
                                                        )
                                                    );
                                                    if (arquivosValidos.length !== arquivos.length) {
                                                        alert("Apenas arquivos ZIP são permitidos.");
                                                        event.target.value = "";
                                                        return;
                                                    }
                                                    setFilesSelected(arquivosValidos);
                                                }}
                                            />
                                        </Button>
                                    </CardContent>
                                </Card>

                                <Card>
                                    <CardContent>
                                        <Typography
                                            sx={{
                                                mb: 2,
                                                fontWeight: 600,
                                            }}
                                        >
                                            Arquivos Selecionados
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ mb: 2 }}
                                        >
                                            {filesSelected.length} arquivo(s) pronto(s) para importação
                                        </Typography>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 1,
                                                maxHeight: 220,
                                                overflowY: "auto",
                                            }}
                                        >
                                            {filesSelected.map((file, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        border: "1px solid #E5E7EB",
                                                        borderRadius: 2,
                                                        p: 1.5,
                                                    }}
                                                >
                                                    <Box>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 500,
                                                                fontSize: "0.9rem",
                                                            }}
                                                        >
                                                            📦 {file.name}
                                                        </Typography>

                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                        >
                                                            {(file.size / 1024 / 1024).toFixed(2)} MB
                                                        </Typography>
                                                    </Box>

                                                    <Typography
                                                        sx={{
                                                            color: "#22C55E",
                                                            fontWeight: 600,
                                                            fontSize: "0.8rem",
                                                        }}
                                                    >
                                                        Pronto
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>

                                        {filesSelected.length > 0 && (
                                            <Box
                                                sx={{
                                                    mt: 2,
                                                    pt: 2,
                                                    borderTop: "1px solid #eee",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <Typography fontWeight={600}>
                                                    Total
                                                </Typography>

                                                <Typography color="primary" fontWeight={700}>
                                                    {(
                                                        filesSelected.reduce(
                                                            (acc, file) => acc + file.size,
                                                            0
                                                        ) /
                                                        1024 /
                                                        1024
                                                    ).toFixed(2)}
                                                    {" "}MB
                                                </Typography>
                                            </Box>
                                        )}
                                    </CardContent>
                                </Card>
                            </Box>

                            {/* LADO DIREITO */}
                            <Box
                                sx={{
                                    flex: 1,
                                    minWidth: "300px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                }}
                            >
                                {/* Cards Estatísticas */}
                                {/* <Box
                                    sx={{
                                        display: "flex",
                                        gap: 2,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {[
                                        // {
                                        //     titulo: "ARQUIVOS ENVIADOS",
                                        //     valor: filesSelected.length,
                                        //     icon: <DescriptionOutlinedIcon />,
                                        //     bg: "#fff",
                                        // },
                                        // {
                                        //     titulo: "SUCESSO",
                                        //     valor: "0",
                                        //     icon: <CheckCircleOutlineOutlinedIcon />,
                                        //     bg: "#ECFDF5",
                                        // },
                                        // {
                                        //     titulo: "PENDENTES",
                                        //     valor: "0",
                                        //     icon: <HourglassEmptyOutlinedIcon />,
                                        //     bg: "#FFFBEB",
                                        // },
                                        // {
                                        //     titulo: "ERROS",
                                        //     valor: "0",
                                        //     icon: <ErrorOutlineOutlinedIcon />,
                                        //     bg: "#FEF2F2",
                                        // },
                                    ].map((item, index) => (
                                        <Card
                                            key={index}
                                            sx={{
                                                flex: "1 1 calc(50% - 8px)",
                                                background: item.bg,
                                                minHeight: 120,
                                            }}
                                        >
                                            <CardContent>
                                                {item.icon}

                                                <Typography
                                                    sx={{
                                                        mt: 2,
                                                        fontSize: 13,
                                                        color: "#666",
                                                    }}
                                                >
                                                    {item.titulo}
                                                </Typography>

                                                <Typography
                                                    variant="h6"
                                                    fontWeight={700}
                                                >
                                                    {item.valor}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    ))}
                                </Box> */}

                                {/* Botão Processar */}
                                <Card
                                    sx={{
                                        background: loading ? "#ccc" : "linear-gradient(135deg,#2563EB,#3B82F6)",
                                        color: loading ? "#666" : "#fff",
                                        cursor: loading ? "not-allowed" : "pointer",
                                    }}
                                    onClick={() => {
                                        if (filesSelected.length === 0) {
                                            alert("Selecione pelo menos um arquivo para processar.");
                                            return;
                                        }
                                        if (loading) {
                                            return;
                                        }
                                        handleProcessFiles();
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box>
                                            <Typography fontWeight={700}>
                                               {loading ? "Processando..." : "Processar Arquivos"}
                                            </Typography>

                                            <Typography variant="body2">
                                                {loading ? "Aguarde enquanto os arquivos são processados." : "Finalizar importação e registrar no sistema"}
                                            </Typography>
                                        </Box>

                                        <ArrowForwardIosIcon />
                                    </CardContent>
                                </Card>

                                {/* Aviso */}
                                <Card
                                    sx={{
                                        background: "#F8FAFC",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            gap: 2,
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <InfoOutlinedIcon color="primary" />

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                        >
                                            Certifique-se de que os arquivos PDF
                                            não estão protegidos por senha para
                                            evitar erros no processamento.
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    )
}